<template>
  <div class="content">
    <a-form :form="form">
      <div class="row" v-if="!datasetId">
        <a-form-item :label="'文件名称'">
          <a-select
            v-decorator="['fileInx', { rules: [{ required: true, message: '请输入知识库名称' }] }]"
            style="width: 540px"
            @change="handleChange"
            placeholder="请选择文件名称"
          >
            <a-select-option :value="inx" v-for="(item, inx) in fileList" :key="inx">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </div>
      <div class="row">
        <a-form-item :label="'分段设置'">
          <a-input style="display: none;" v-decorator="['separator', { rules: [{ required: true, message: '' }] }]" />
          <div class="chunk">
            <div class="fdsz-box">
              <div :class="['header', segmentedType === 1 ? 'current' : '']" @click="segmentedType = 1">
                通用分段
                <p class="tip">通用文本分块模式，检索和召回的块是相同的</p>
              </div>
              <div class="content" v-if="segmentedType === 1">
                <div class="fdsz-item">
                  <div class="fdsz-item-box">
                    <div>
                      <a-form-item :label="'分段标识符'">
                        <a-input
                          v-decorator="['separator', { rules: [{ required: true, message: '请输入分段标识符' }] }]"
                          style="width: 100%"
                          type="text"
                          placeholder="\n\n用于分段 \n 用于分行"
                        />
                      </a-form-item>
                    </div>
                    <div style="position: relative;">
                      <a-form-item :label="'分段最大长度'">
                        <a-input-number
                          v-decorator="['maxTokens', { rules: [{ required: true, message: '请输入分段最大长度' }] }]"
                          style="width: 100%"
                          :min="1"
                          :max="4000"
                          placeholder="最大长度<= 4000"
                        />
                      </a-form-item>
                      <span style="color: #5E7A92; position: absolute; right: 30px; top: 36px;">tokens</span>
                    </div>
                    <div style="position: relative;">
                      <a-form-item :label="'分段重叠长度'">
                        <a-input-number
                          v-decorator="['chunkOverlap', { rules: [{ required: true, message: '请输入分段重叠长度' }] }]"
                          style="width: 100%"
                          :min="1"
                          :max="4000"
                          placeholder="分段重叠长度"
                        />
                      </a-form-item>
                      <span style="color: #5E7A92; position: absolute; right: 30px; top: 36px;">tokens</span>
                      <a-tooltip>
                        <template slot="title">
                          建议设置分段长度为最大分段长度的10%-25%
                        </template>
                        <img class="tips" src="@/assets/icons/icon_wh@2x.png" alt="" />
                      </a-tooltip>
                    </div>
                  </div>
                  <div>
                    <div>
                      <a-form-item :label="'文本预处理规则'">
                        <a-checkbox-group v-decorator="['pretreatment', {}]" name="checkboxgroup">
                          <a-row>
                            <a-checkbox value="removeExtraSpaces">替换掉连续的空格、换行符和制表符</a-checkbox>
                          </a-row>
                          <a-row style="margin-top: 5px;">
                            <a-checkbox value="removeUrlsEmails">删除所有 URL 和电子邮件地址</a-checkbox>
                          </a-row>
                        </a-checkbox-group>
                      </a-form-item>
                    </div>
                  </div>
                  <a-button class="resetBtn" @click="resetFormToDefault">重置</a-button>
                </div>
              </div>
            </div>
            <!-- <div class="fdsz-box">
              <div :class="['header', segmentedType === 2 ? 'current' : '']" @click="segmentedType = 2">
                父子分段
                <p class="tip">使用父子模式时，子块用于检索，父块用作上下文</p>
              </div>
              <div class="content" v-if="segmentedType === 2">
                <div class="fdsz-type">
                  <div :class="['fdsz-type-item', fzfdType === 1 ? 'current' : '']" @click="fzfdType = 1">
                    <p class="title">段落</p>
                    <p style="font-size: 12px;">
                      此模式根据分离符和最大块长度将文本拆分成段落，<br />
                      使用拆分文本作为检索的父块
                    </p>
                  </div>
                  <div :class="['fdsz-type-item', fzfdType === 2 ? 'current' : '']" @click="fzfdType = 2">
                    <p class="title">全文</p>
                    <p style="font-size: 12px;">
                      整个文档用作父块并直接检索，<br />
                      请注意，出于性能原因，超过10000个标记的文本将被自动截断。
                    </p>
                  </div>
                </div>
                <div class="fdsz-item">
                  <div :class="['fdsz-item-box', 'fzfd-item-box', fzfdType === 2 ? 'full' : '']">
                    <div v-if="fzfdType === 1">
                      <a-form-item :label="'分段标识符'">
                        <a-input
                          v-decorator="['separator', { rules: [{ required: true, message: '请输入分段标识符' }] }]"
                          style="width: 100%"
                          type="text"
                          placeholder="\n\n用于分段 \n 用于分行"
                        />
                      </a-form-item>
                    </div>
                    <div style="position: relative;" v-if="fzfdType === 1">
                      <a-form-item :label="'分段最大长度'">
                        <a-input-number
                          v-decorator="['maxTokens', { rules: [{ required: true, message: '请输入分段最大长度' }] }]"
                          style="width: 100%;"
                          :min="1"
                          :max="4000"
                          placeholder="最大长度<= 4000"
                        >
                        </a-input-number>
                      </a-form-item>
                      <span style="color: #5E7A92; position: absolute; right: 30px; top: 40px;">tokens</span>
                    </div>
                    <div>
                      <a-form-item :label="'子块用于检索分段标识符'">
                        <a-input
                          v-decorator="['subSeparator', { rules: [{ required: true, message: '请输入分段标识符' }] }]"
                          style="width: 100%"
                          type="text"
                          placeholder="\n\n用于分段 \n 用于分行"
                        />
                      </a-form-item>
                    </div>
                    <div style="position: relative;">
                      <a-form-item :label="'分段最大长度'">
                        <a-input-number
                          v-decorator="['subMaxTokens', { rules: [{ required: true, message: '请输入分段最大长度' }] }]"
                          style="width: 100%"
                          :min="1"
                          :max="4000"
                          placeholder="最大长度<4000"
                        />
                      </a-form-item>
                      <span style="color: #5E7A92; position: absolute; right: 30px; top: 40px;">tokens</span>
                    </div>
                  </div>
                  <div>
                    <div>
                      <a-form-item :label="'文本预处理规则'">
                        <a-checkbox-group v-decorator="['pretreatment', {}]" name="checkboxgroup">
                          <a-row>
                            <a-checkbox value="removeExtraSpaces">替换掉连续的空格、换行符和制表符</a-checkbox>
                          </a-row>
                          <a-row>
                            <a-checkbox value="removeUrlsEmails">删除所有 URL 和电子邮件地址</a-checkbox>
                          </a-row>
                        </a-checkbox-group>
                      </a-form-item>
                    </div>
                  </div>
                  <a-button>重置</a-button>
                </div>
              </div>
            </div> -->
          </div>
        </a-form-item>
      </div>
      <!-- <div class="row">
        <a-form-item :label="'混合检索'">
          <a-input
            style="display: none;"
            v-decorator="['separator', { rules: [{ required: true, message: '请输入混合检索' }] }]"
          />
          <div class="chunk">
            <div :class="['hhjs-item', hhjsType === 1 ? 'current' : '']" @click="hhjsType = 1">
              <div>
                <div class="title">权重设置</div>
                <div>通过调整分配的权重，重新排序策略确定是优先进行语义匹配还是关键字匹配</div>
              </div>
              <div class="slider" v-if="hhjsType === 1">
                <a-slider :default-value="50" />
                <div class="left-tips">语义0.5</div>
                <div class="right-tips">0.5关键词</div>
              </div>
            </div>
            <div :class="['hhjs-item', hhjsType === 2 ? 'current' : '']" @click="hhjsType = 2">
              <div>
                <div class="title">模型设置</div>
                <div>重排序模型将根据候选文档列表与用户问题语义匹配度进度重新排序，从而改进语义排序的结果</div>
              </div>
            </div>
            <div class="num">
              <div class="num-item">
                <div class="input-num">
                  <a-input-number v-model="topK" style="width: 100%;" />
                  <div class="label">
                    Top K
                    <img src="@/assets/icons/icon_whao@2x.png" alt="" />
                  </div>
                </div>
                <div class="slider">
                  <a-slider :default-value="topK" />
                </div>
              </div>
              <div class="num-item">
                <div class="input-num">
                  <a-input-number v-model="score" style="width: 100%;" />
                  <div class="label">
                    <a-switch size="small" default-checked @change="onChange" />
                    <div>Score阈值</div>
                    <img src="@/assets/icons/icon_whao@2x.png" alt="" />
                  </div>
                </div>
                <div class="slider">
                  <a-slider :default-value="score" />
                </div>
              </div>
            </div>
          </div>
        </a-form-item>
      </div> -->
      <div class="row" v-if="!datasetId">
        <div class="label">选项应用:</div>
        <div>
          <a-checkbox v-model="fullApply" @change="fullApply ? (fullApplyVisible = true) : (fullApplyVisible = false)">
            以上规则应用到全部文件
          </a-checkbox>
        </div>
      </div>
    </a-form>
    <TipModal
      @ok="
        fullApply = true
        fullApplyVisible = false
      "
      :visible="fullApplyVisible"
      @cancel="
        fullApply = false
        fullApplyVisible = false
      "
      :desc="
        `
        <p>确定全部文件<br />按照当前文件的设置方式应用</p>
        <p class='placeholder'></p>`
      "
    />
  </div>
</template>

<script>
import { getDocumentDetail } from '@/api/ai.js'
import TipModal from '@/components/tipModal/index.vue'

export default {
  name: 'FileSet',
  components: {
    TipModal
  },
  props: {
    fileList: {
      type: Array,
      default: () => []
    },
    datasetId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      segmentedType: 1, // 1-通用文本 2-父子分段
      fzfdType: 1, // 1-段落 2-全文
      hhjsType: 1, // 1-权重 2-模型
      score: 50,
      topK: 50,
      fullApply: false,
      completeFileList: [],
      currentFileIndex: 0, // 当前选中的文件索引
      fileConfigs: [], // 存储每个文件的配置
      fullApplyVisible: false
    }
  },
  mounted() {
    // 如果有文件列表且不是编辑模式，则设置默认选中第一个文件
    if (this.fileList.length > 0 && !this.datasetId) {
      this.$nextTick(() => {
        this.initFileConfigs()
        this.form.setFieldsValue({
          fileInx: 0,
          ...this.getFormValuesFromConfig(0)
        })
      })
    } else {
      this.getDocumentDetail()
    }
    // this.$nextTick(() => {
    //   // 初始化每个文件的配置
    //   this.form.setFieldsValue({
    //     ...this.getFormValuesFromConfig(0)
    //   })
    // })
  },
  methods: {
    // 初始化每个文件的配置
    initFileConfigs() {
      this.fileConfigs = this.fileList.map(() => ({
        segmentedType: 1,
        fzfdType: 1,
        separator: '\\n\\n',
        maxTokens: 500,
        chunkOverlap: 50,
        subSeparator: '',
        subMaxTokens: 500,
        subChunkOverlap: 50,
        pretreatment: ['removeExtraSpaces']
      }))
      console.log('this.fileConfigs', this.fileConfigs)
    },

    // 从配置中获取表单值
    getFormValuesFromConfig(index) {
      const config = this.fileConfigs[index] || this.fileConfigs[0]
      return {
        separator: config.separator,
        maxTokens: config.maxTokens,
        chunkOverlap: config.chunkOverlap,
        subSeparator: config.subSeparator,
        subMaxTokens: config.subMaxTokens,
        subChunkOverlap: config.subChunkOverlap,
        pretreatment: config.pretreatment
      }
    },

    // 保存当前表单值到配置
    saveCurrentFormToConfig() {
      if (this.currentFileIndex < 0 || !this.fileConfigs[this.currentFileIndex]) return

      this.form.validateFields((err, values) => {
        if (!err) {
          this.fileConfigs[this.currentFileIndex] = {
            ...this.fileConfigs[this.currentFileIndex],
            segmentedType: this.segmentedType,
            fzfdType: this.fzfdType,
            separator: values.separator,
            maxTokens: values.maxTokens,
            chunkOverlap: values.chunkOverlap,
            subSeparator: values.subSeparator,
            subMaxTokens: values.subMaxTokens,
            subChunkOverlap: values.subChunkOverlap,
            pretreatment: values.pretreatment
          }
        }
      })
    },

    // 处理文件选择变化
    handleChange(value) {
      // 先保存当前文件的配置
      this.saveCurrentFormToConfig()

      // 更新当前文件索引
      this.currentFileIndex = value

      // 加载选中文件的配置
      const config = this.fileConfigs[value]
      if (config) {
        this.segmentedType = config.segmentedType
        this.fzfdType = config.fzfdType

        // 更新表单值
        this.$nextTick(() => {
          this.form.setFieldsValue(this.getFormValuesFromConfig(value))
        })
      }
    },
    // 将此方法保留为一个代理方法，用于保存当前配置并触发事件
    createDatasetDoc() {
      // 保存当前表单的配置
      this.saveCurrentFormToConfig()

      return new Promise((resolve, reject) => {
        // 验证表单
        this.form.validateFields((err, values) => {
          if (!err) {
            // 处理所有文件配置中的分隔符转义字符
            const processedConfigs = this.fileConfigs.map(config => ({
              ...config,
              separator: config.separator.replace(/\\n/g, '\n'),
              subSeparator: config.subSeparator ? config.subSeparator.replace(/\\n/g, '\n') : ''
            }))

            resolve(true)
            // 发出事件，通知父组件可以调用DataProcessing的提交方法
            this.$emit('configReady', {
              fileConfigs: processedConfigs,
              currentFileIndex: this.currentFileIndex,
              fullApply: this.fullApply,
              fileList: this.fileList
            })
          } else {
            resolve(false)
          }
        })
      })
    },
    getDocumentDetail() {
      getDocumentDetail({ documentId: this.$route.query.id }).then(res => {
        if (res.code === 200) {
          const { data } = res
          const fileName = data?.extendBody?.name || '未知.docx'
          const fileType = fileName
            .split('.')
            .pop()
            .toLowerCase()
          const iconMap = {
            doc: require('@/assets/icons/icon_word.png'),
            docx: require('@/assets/icons/icon_word.png'),
            pdf: require('@/assets/icons/icon_pdf.png'),
            xls: require('@/assets/icons/icon_xlsx.png'),
            xlsx: require('@/assets/icons/icon_xlsx.png'),
            ppt: require('@/assets/icons/icon_ppt.png'),
            pptx: require('@/assets/icons/icon_ppt.png'),
            txt: require('@/assets/icons/icon_t@2x.png')
          }
          const pretreatment = []

          this.fileList.push({
            name: fileName,
            size: data?.extendBody?.size || '0KB',
            type: '文档',
            icon: iconMap[fileType],
            editing: false,
            file: null
          })

          // 设置表单数据
          this.segmentedType = data.docForm === 'text_model' ? 1 : 2
          this.fzfdType = data.processRule.parentMode === 'paragraph' ? 1 : 2

          // 处理separator中的换行符转义
          const separator = (data.processRule.segmentation?.separator).replace(/\n/g, '\\n') || '\\n\\n'

          this.form.setFieldsValue({
            separator,
            maxTokens: data.processRule.segmentation?.maxTokens || 500,
            chunkOverlap: data.processRule.segmentation?.chunkOverlap || 50
          })
          if (data.processRule.removeExtraSpaces) {
            pretreatment.push('removeExtraSpaces')
          }
          if (data.processRule.removeUrlsEmails) {
            pretreatment.push('removeUrlsEmails')
          }
          this.form.setFieldsValue({
            pretreatment
          })
          if (data.docForm === 'hierarchical_model' && data.processRule.parentMode === 'paragraph') {
            const subSeparator = (data.processRule.subSegmentation?.separator).replace(/\n/g, '\\n') || '\\n\\n'
            this.form.setFieldsValue({
              subSeparator,
              subMaxTokens: data.processRule.subSegmentation?.maxTokens || 500,
              subChunkOverlap: data.processRule.subSegmentation?.chunkOverlap || 50
            })
          }
          // 配置默认值
          this.fileConfigs = [
            {
              separator: data.processRule.segmentation?.separator || '\\n\\n',
              maxTokens: data.processRule.segmentation?.maxTokens || 500,
              chunkOverlap: data.processRule.segmentation?.chunkOverlap || 50,
              subSeparator: data.processRule.subSegmentation?.separator || '\\n\\n',
              subMaxTokens: data.processRule.subSegmentation?.maxTokens || 500,
              subChunkOverlap: data.processRule.subSegmentation?.chunkOverlap || 50,
              pretreatment: pretreatment
            }
          ]
        }
      })
    },
    // 添加重置方法
    resetFormToDefault() {
      // 默认值配置
      const defaultValues = {
        separator: '\\n\\n',
        maxTokens: 500,
        chunkOverlap: 50,
        pretreatment: ['removeExtraSpaces']
      }

      // 重置表单值
      this.form.setFieldsValue(defaultValues)

      // 更新当前文件的配置
      if (this.currentFileIndex >= 0 && this.fileConfigs[this.currentFileIndex]) {
        this.fileConfigs[this.currentFileIndex] = {
          ...this.fileConfigs[this.currentFileIndex],
          ...defaultValues,
          segmentedType: 1,
          fzfdType: 1
        }
      }

      // 重置分段类型
      this.segmentedType = 1
      this.fzfdType = 1
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  /deep/ .ant-form-item label {
    font-weight: bold;
  }
  /deep/ .ant-form-item-label {
    height: 35px;
  }
  .required::after {
    content: '*';
    color: red;
  }
  .row {
    display: flex;
    align-items: flex-start;
    // margin-bottom: 20px;
    /deep/ .ant-form-item {
      width: 100%;
    }
    .label {
      width: 80px;
      font-weight: bold;
      color: #000;
    }
    .chunk {
      margin-top: -5px;
      .fdsz-box {
        flex-direction: column;
        border: solid 1px #d8dce0;
        border-radius: 4px;
        overflow: hidden;
        margin-top: 10px;
        .header {
          height: 65px;
          background: #f9fafb;
          padding: 17px 20px;
          line-height: 0.5em;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
          font-size: 14px;
          font-weight: bold;
          cursor: pointer;
          color: #000;
          .tip {
            font-size: 14px;
            color: #7b9bb4;
            margin: 0;
            line-height: 1;
            margin-top: 12px;
            font-weight: normal;
          }
        }
        .current {
          background: #edf2f6;
        }
        /deep/ .ant-form-item {
          margin-bottom: 0;
        }
        .content {
          padding: 20px;
          border-radius: 5px;
          background-color: #fdfdfd;
          .fdsz-item {
            margin-right: 30px;
            /deep/ .resetBtn {
              color: #72a6e9;
              border-color: #b5c5da;
            }
            .fdsz-item-box {
              display: flex;
              justify-content: space-between;
              align-items: center;
              > div {
                width: 30%;
              }
              .tips {
                width: 16px;
                height: 16px;
                position: absolute;
                left: 107px;
                top: 2px;
                &:hover {
                  content: url('~@/assets/icons/icon_w_d@2x.png');
                }
              }
            }
            .fzfd-item-box {
              > div {
                width: 22%;
              }
            }
            .full {
              > div {
                width: 49%;
              }
            }
            > div {
              margin-bottom: 5px;
            }
          }
          .fdsz-type {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #edf2f6;
            border: solid 1px #edf2f6;
            border-radius: 5px;

            > div {
              width: 50%;
              border-radius: 5px;
              &:nth-child(2) {
                border-left: none;
              }
            }
            .fdsz-type-item {
              height: 80px;
              text-align: center;
              padding-top: 10px;
              cursor: pointer;
              p {
                margin: 0;
                line-height: 1.5em;
                color: #7b9bb4;
              }
              .title {
                font-weight: bold;
                color: #374d5e;
              }
            }
            .current {
              background: #fffbf9;
              p {
                color: #f46d36 !important;
              }
            }
          }
        }
      }
      .hhjs-item {
        border: solid 1px #d8dce0;
        border-radius: 4px;
        padding: 10px;
        margin-bottom: 10px;
        font-size: 12px;
        height: 65px;
        background: #f9fafb;
        line-height: 1.8em;
        color: #666666;
        cursor: pointer;
        padding: 10px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .title {
          font-weight: bold;
          font-size: 14px;
          color: #000;
        }
        .slider {
          width: 600px;
          position: relative;
          margin-top: -16px;
          .left-tips {
            position: absolute;
            left: 5px;
            top: 25px;
          }
          .right-tips {
            position: absolute;
            right: 0px;
            top: 25px;
          }
        }
      }
      .current {
        background: #fffbf9;
        .title {
          color: #f46d36 !important;
        }
      }
      .num {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 40px;
        padding-right: 10px;
        .num-item {
          width: 40%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .input-num {
            width: 150px;
            margin-right: 30px;
            position: relative;
            .label {
              width: 150px;
              position: absolute;
              top: -30px;
              left: 0;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              img {
                width: 16px;
                height: 16px;
                margin-left: 5px;
                margin-top: -20px;
              }
              > div {
                margin-left: 5px;
                margin-top: -4px;
              }
            }
          }
          .slider {
            flex: 1;
          }
        }
      }
    }
  }
  /deep/ .ant-slider-track {
    background: #f46d36;
  }
  /deep/ .ant-slider-handle {
    border-radius: 5px;
    background-color: #ff8f69;
    border: 2px solid #fff;
  }
  /deep/ .ant-slider-handle:focus {
    box-shadow: 0 0 0 5px rgba(255, 143, 105, 0.2);
  }
}
</style>
